import React, { useState } from "react";
import { Link } from "react-router-dom";

import { TiUserAdd } from "react-icons/ti";
import Swal from "sweetalert2";
import { apiPath, RoutePath } from "../../utility/Constant";
import { deleteData } from "../../hooks/delete";

const UserCard = ({ user }) => {
  const images = [
    "https://static.vecteezy.com/system/resources/previews/002/025/839/non_2x/illustration-of-engineer-icon-with-cogwheel-free-vector.jpg",
    "https://media.istockphoto.com/id/1187828049/vector/writing-hand-glyph-icon.jpg?s=612x612&w=0&k=20&c=bsIPDKXPM85N4f2XCuwil3FITKOc9zG4EnHsUOIFpLU=",
    "https://i.ibb.co/bKrrC5x/viewer.png",
  ];

  const [hidden, setHidden] = useState(false);
  const { addUser } = RoutePath;
  const { users } = apiPath;
  const handleDelete = (event) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteData(`${users}/${event.target.id}`);
        setTimeout(() => {
          setHidden(true);
        }, 1000);
      }
    });
  };
  return (
    <div className={hidden && "hidden"}>
      {user ? (
        <div className="card bg-base-100 shadow-xl">
          <figure>
            <img
              src={
                (user.role === "admin" && images[0]) ||
                (user.role === "moderator" && images[1]) ||
                (user.role === "viewer" && images[2])
              }
              alt={user.firstName + " " + "Image"}
              className="min-h-[275px] object-cover w-full"
            />
          </figure>

          <div className="p-3">
            <h2 className="text-2xl text-center uppercase font-semibold">
              {user.firstName}
            </h2>
            <p className="text-center text-lg pb-4">{user.role}</p>
            <div className="card-actions justify-between">
              <Link
                to={`/manage-users/${user.id}`}
                className="btn btn-outline btn-xs border-blue-500 text-blue-500 hover:bg-blue-500 hover:border-blue-500 hover:text-white"
              >
                Edit
              </Link>
              {user.primary !== "true" && (
                <button
                  id={user.id}
                  onClick={handleDelete}
                  className="btn btn-outline btn-xs border-red-500 text-red-500 hover:bg-red-500 hover:border-red-500 hover:text-white"
                >
                  Delete
                </button>
              )}
            </div>
          </div>
        </div>
      ) : (
        <Link
          to={addUser}
          className="flex justify-center items-center rounded-xl bg-gray-50 shadow-xl h-full "
        >
          <p className="text-8xl">
            <TiUserAdd />
          </p>
        </Link>
      )}
    </div>
  );
};

export default UserCard;
